import { useTypedSelector } from "@lib/redux";
import { StyledHeaderLeftMobile } from "./index.styled";
import { StyledHeaderButton } from "@lib/components/StyledComponents/layout";
import { TbMenu2 } from "react-icons/tb";
import { IRouteConfig } from "@lib/types/Routes";
import { useState } from "react";
import AdminDrawerMenu from "@lib/components/AppComponents/AppLayout/Admin/AdminDrawerMenu";

type Props = {
  routesConfig: IRouteConfig[];
};

export default function AdminHeaderLeftMobile({ routesConfig }: Props) {
  const { window, header } = useTypedSelector((state) => state.screen);
  const breakpointHide = window?.breakpointHide;
  const height = header?.height;
  const [open, setOpen] = useState(false);

  return (
    <StyledHeaderLeftMobile mediaWidth={breakpointHide}>
      <StyledHeaderButton onClick={() => setOpen(true)}>
        <TbMenu2 />
      </StyledHeaderButton>

      <AdminDrawerMenu
        open={open}
        setOpen={setOpen}
        routesConfig={routesConfig}
        height={height}
      />
    </StyledHeaderLeftMobile>
  );
}
